module.exports = __webpack_public_path__ + "media/images/about_us_greg-cf2ba9ce48fad443ec657376c70ac4f18337395a3dd87a6423dc0765cd612bd8.jpg";